<template>
    <div>
        <div v-if="!loggedInStatus" class="entry-content bg-gray-100 py-8">
            <div v-if="hasSessionEnded" class="bg-white p-8 py-4 text-center">
                Du har blivit utloggad på grund av inaktivitet.
            </div>

            <div v-if="loggedOut" class="bg-white p-8 py-4 text-center">Tack för ditt besök. Du har nu loggats ut.</div>

            <div v-if="activeMessageLogin" class="bg-yellow-200 p-8 py-4 text-center" v-html="messageOnLoginPage"></div>

            <section class="bg-white my-4 lg:flex mx-auto">
                <div class="lg:flex w-full border-solid border-b-8 pb-8 border-gray-600 mimer-purple-border-color">
                    <div class="w-full p-8" v-if="!companyLogin">
                        <h3 class="block h3 mt-0">Logga in med BankID</h3>
                        <!-- <div class="flex mb-4">
                            <button
                                role="button"
                                type="submit"
                                @click="scriveSignInBankId"
                                class="w-full p-2 px-4 text-white bg-mimer-purple mt-4 mb-4 underline rounded-lg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 169 158"
                                    class="h-6 inline-block mr-2">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#ffffff">
                                            <g>
                                                <path
                                                    d="M45.916 135.23c5.268 0 9.905 2.083 9.015 7.63l-1.005 6.257c-.355 2.211-.289 2.873 2.253 2.922l-2.583 5.878c-4.495.291-6.67-.167-7.75-2.046-2.384 1.422-5.006 2.129-7.814 2.129-5.093 0-6.845-2.541-6.392-5.378.213-1.34 1.03-2.67 2.328-3.756 2.794-2.336 9.715-2.673 12.42-4.462.236-2.002-.6-2.712-3.15-2.712-2.979 0-5.466.961-9.714 3.754l1.035-6.47c3.698-2.58 7.251-3.747 11.357-3.747zm32.032 0c4.892 0 7.172 3.008 6.407 7.968L82.075 158h-8.773l1.889-12.256c.342-2.244-.3-3.266-2.028-3.266-1.392 0-2.649.764-3.872 2.414L67.27 158H58.5l3.446-22.395h8.774l-.452 2.929c2.772-2.376 4.896-3.305 7.68-3.305zm22.058-7.436l-2.19 14.881 8.377-8.065H117l-10.759 9.971L114.866 158h-10.973l-6.656-10.808h-.082L95.567 158H86.82l4.438-30.206h8.747zm-78.437.93c7.265 0 9.048 3.578 8.525 6.855-.423 2.664-2.276 4.617-5.514 5.906 4.08 1.496 5.669 3.863 5.084 7.52-.733 4.616-4.87 8.066-10.257 8.066H0l4.514-28.347h17.055zm131.362 0c11.337 0 14.611 7.98 13.563 14.547-1.03 6.442-6.288 13.8-16.25 13.8h-16.53l4.532-28.347h14.685zm-19.681 0l-4.553 28.347h-10.304l4.554-28.347h10.303zm-87.452 19.348c-2.392 1.462-6.8 1.21-7.281 4.213-.228 1.42.685 2.46 2.151 2.46 1.427 0 3.164-.583 4.517-1.5-.091-.498-.047-1.042.113-2.043l.5-3.13zm-30.297-3.262h-3.332l-1.265 7.938h3.076c3.421 0 5.43-1.33 5.872-4.115.38-2.37-1.017-3.823-4.351-3.823zm134.677-9.357h-2.75l-2.379 14.884h2.707c4.978 0 7.721-2.37 8.535-7.439.595-3.741-.573-7.445-6.113-7.445zm-133.187-2.41h-2.95l-1.185 7.44h2.95c3.334 0 4.889-1.704 5.212-3.74.344-2.158-.692-3.7-4.027-3.7zM43.87 14.405c3.239 0 5.74.667 7.04 1.88.907.849 1.245 1.96.977 3.219-.26 1.215-1.64 2.797-3.71 4.223-5.866 4.066-4.85 8.28-4.397 9.477 1.358 3.601 5.892 5.544 9.462 5.544h7.58l-7.07 43.956h.121c-2.632 16.426-4.59 28.813-4.953 31.148H6.964c.804-5.165 11.305-70.804 11.97-75.091h.645l2.179.005h.502l1.696.004.446.001.62.001h.371l.172.001.451.001h.504l.058.001h.076c5.043-.027 9.69-2.3 11.844-5.793 2.106-3.388 1.305-7.02-2.076-9.482-1.127-.818-2.424-2.145-2.17-3.787.348-2.217 4.171-5.308 9.617-5.308zM109.119 0c38.623 0 65.555 16.776 58.858 58.635-5.415 33.793-32.973 55.218-66.709 55.218H93.27l5.425-34.104c13.664-.152 25.113-6.51 27.478-21.265 2.54-15.881-5.526-22.699-20.537-22.815.003-.024.003-.037.003-.037h-11.04c-2.542 0-5.808-1.395-6.655-3.641-.264-.696-.802-3.206 3.314-6.068 1.58-1.101 4.324-3.347 4.9-6.034.471-2.252-.198-4.429-1.845-5.967-1.876-1.757-5.01-2.69-9.061-2.69-6.765 0-11.939 4.042-12.527 7.813-.037.245-.061.532-.061.846 0 1.5.59 3.709 3.397 5.763 1.03.753 2.028 1.86 2.028 3.341 0 .679-.21 1.43-.723 2.267-1.608 2.612-5.341 4.378-9.301 4.4l-7.243-.017L66.526 0z"
                                                    transform="translate(-100 -239) translate(100 239)" />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                Scrive Mobilt BankID / BankID
                            </button>
                        </div> -->
                        <div class="flex mb-4">
                            <button
                                role="button"
                                type="submit"
                                @click="signinBankID"
                                class="w-full p-2 px-4 text-white bg-mimer-purple mt-4 mb-4 underline rounded-lg">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 169 158"
                                    class="h-6 inline-block mr-2">
                                    <g fill="none" fill-rule="evenodd">
                                        <g fill="#ffffff">
                                            <g>
                                                <path
                                                    d="M45.916 135.23c5.268 0 9.905 2.083 9.015 7.63l-1.005 6.257c-.355 2.211-.289 2.873 2.253 2.922l-2.583 5.878c-4.495.291-6.67-.167-7.75-2.046-2.384 1.422-5.006 2.129-7.814 2.129-5.093 0-6.845-2.541-6.392-5.378.213-1.34 1.03-2.67 2.328-3.756 2.794-2.336 9.715-2.673 12.42-4.462.236-2.002-.6-2.712-3.15-2.712-2.979 0-5.466.961-9.714 3.754l1.035-6.47c3.698-2.58 7.251-3.747 11.357-3.747zm32.032 0c4.892 0 7.172 3.008 6.407 7.968L82.075 158h-8.773l1.889-12.256c.342-2.244-.3-3.266-2.028-3.266-1.392 0-2.649.764-3.872 2.414L67.27 158H58.5l3.446-22.395h8.774l-.452 2.929c2.772-2.376 4.896-3.305 7.68-3.305zm22.058-7.436l-2.19 14.881 8.377-8.065H117l-10.759 9.971L114.866 158h-10.973l-6.656-10.808h-.082L95.567 158H86.82l4.438-30.206h8.747zm-78.437.93c7.265 0 9.048 3.578 8.525 6.855-.423 2.664-2.276 4.617-5.514 5.906 4.08 1.496 5.669 3.863 5.084 7.52-.733 4.616-4.87 8.066-10.257 8.066H0l4.514-28.347h17.055zm131.362 0c11.337 0 14.611 7.98 13.563 14.547-1.03 6.442-6.288 13.8-16.25 13.8h-16.53l4.532-28.347h14.685zm-19.681 0l-4.553 28.347h-10.304l4.554-28.347h10.303zm-87.452 19.348c-2.392 1.462-6.8 1.21-7.281 4.213-.228 1.42.685 2.46 2.151 2.46 1.427 0 3.164-.583 4.517-1.5-.091-.498-.047-1.042.113-2.043l.5-3.13zm-30.297-3.262h-3.332l-1.265 7.938h3.076c3.421 0 5.43-1.33 5.872-4.115.38-2.37-1.017-3.823-4.351-3.823zm134.677-9.357h-2.75l-2.379 14.884h2.707c4.978 0 7.721-2.37 8.535-7.439.595-3.741-.573-7.445-6.113-7.445zm-133.187-2.41h-2.95l-1.185 7.44h2.95c3.334 0 4.889-1.704 5.212-3.74.344-2.158-.692-3.7-4.027-3.7zM43.87 14.405c3.239 0 5.74.667 7.04 1.88.907.849 1.245 1.96.977 3.219-.26 1.215-1.64 2.797-3.71 4.223-5.866 4.066-4.85 8.28-4.397 9.477 1.358 3.601 5.892 5.544 9.462 5.544h7.58l-7.07 43.956h.121c-2.632 16.426-4.59 28.813-4.953 31.148H6.964c.804-5.165 11.305-70.804 11.97-75.091h.645l2.179.005h.502l1.696.004.446.001.62.001h.371l.172.001.451.001h.504l.058.001h.076c5.043-.027 9.69-2.3 11.844-5.793 2.106-3.388 1.305-7.02-2.076-9.482-1.127-.818-2.424-2.145-2.17-3.787.348-2.217 4.171-5.308 9.617-5.308zM109.119 0c38.623 0 65.555 16.776 58.858 58.635-5.415 33.793-32.973 55.218-66.709 55.218H93.27l5.425-34.104c13.664-.152 25.113-6.51 27.478-21.265 2.54-15.881-5.526-22.699-20.537-22.815.003-.024.003-.037.003-.037h-11.04c-2.542 0-5.808-1.395-6.655-3.641-.264-.696-.802-3.206 3.314-6.068 1.58-1.101 4.324-3.347 4.9-6.034.471-2.252-.198-4.429-1.845-5.967-1.876-1.757-5.01-2.69-9.061-2.69-6.765 0-11.939 4.042-12.527 7.813-.037.245-.061.532-.061.846 0 1.5.59 3.709 3.397 5.763 1.03.753 2.028 1.86 2.028 3.341 0 .679-.21 1.43-.723 2.267-1.608 2.612-5.341 4.378-9.301 4.4l-7.243-.017L66.526 0z"
                                                    transform="translate(-100 -239) translate(100 239)" />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                Mobilt BankID / BankID
                            </button>
                        </div>
                        <h3 class="block h3 mt-0">Logga in med lösenord</h3>
                        <div>
                            <div
                                v-if="loggedInError && (details === 404 || details === 401)"
                                class="p-4 bg-red-200 font-bold">
                                <span v-if="details === 404">Kontakta Mimer för hjälp med inloggning.</span>
                                <span v-if="details === 401"
                                    >Inloggning misslyckades. Kontrollera att du angett rätt inloggningsuppgifter. Om du
                                    inte har ett konto, skapa en ny användare för att samla köpoäng och söka
                                    bostad.</span
                                >
                            </div>
                            <span
                                ><form class="mt-4" @submit.prevent="loginUser">
                                    <div class="mb-2">
                                        <label for="Personnummer" class="block uppercase text-sm font-bold mb-2">
                                            Personnummer
                                        </label>
                                        <input
                                            name="Personnummer"
                                            type="text"
                                            pattern="[0-9\-]+"
                                            placeholder="YYYYMMDD-XXXX"
                                            autocomplete="username"
                                            class="bg-gray-100 focus:bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 border-red-500 validated valid hf-in-range"
                                            aria-invalid="false"
                                            v-model="user.userName" />
                                        <div v-if="v$.user.userName.$error" class="text-red text-sm italic pb-2 h-6">
                                            <span v-if="v$.user.userName.$errors[0].$validator === 'required'"
                                                >Fältet Personnummer är obligatoriskt</span
                                            >
                                            <span
                                                v-if="v$.user.userName.$errors[0].$validator === 'validatePersonnummer'"
                                                >Ogiltigt personnummer</span
                                            >
                                        </div>
                                    </div>
                                    <div>
                                        <span
                                            ><label for="Lösenord" class="block uppercase text-sm font-bold mb-2">
                                                Lösenord
                                            </label>
                                            <input
                                                name="Lösenord"
                                                type="password"
                                                placeholder="*********"
                                                autocomplete="off"
                                                class="bg-gray-100 focus:bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4"
                                                style="
                                                    background-repeat: no-repeat;
                                                    background-attachment: scroll;
                                                    background-size: 16px 18px;
                                                    background-position: 98% 50%;
                                                    cursor: auto;
                                                "
                                                v-model="user.password" />
                                            <div
                                                v-if="v$.user.password.$error"
                                                class="text-red text-sm italic pb-2 h-6">
                                                <span v-if="v$.user.password.$errors[0].$validator === 'required'"
                                                    >Fältet Lösenord är obligatoriskt</span
                                                >
                                            </div>
                                        </span>
                                    </div>
                                    <button
                                        role="button"
                                        type="submit"
                                        class="w-full p-2 px-4 text-white bg-mimer-purple mt-4 underline rounded-lg">
                                        <img
                                            v-if="isLogingIn"
                                            src="../assets/3-dots-scale-white-36.svg"
                                            class="mx-auto" />
                                        <span v-else>Logga in</span>
                                    </button>

                                    <a
                                        role="button"
                                        tabindex="0"
                                        class="inline-block text-sm mt-4 no-underline relative pl-6"
                                        @click.prevent="toggleCompanyLogin"
                                        ><span class="material-icons absolute left-0"> change_circle </span> Logga in
                                        som företag</a
                                    >
                                    <router-link
                                        role="link"
                                        class="inline-block text-sm mt-4 float-right no-underline"
                                        :to="'/glomt-losenord'"
                                        >Glömt lösenord</router-link
                                    >
                                </form></span
                            >
                        </div>
                        <a
                            href="/om-mimer/dataskydd-och-hantering-av-personuppgifter/generella-bestammelser-for-hantering-av-personuppgifter/"
                            class="text-sm block mt-6"
                            >Så hanterar vi dina personuppgifter och integritet.</a
                        >
                    </div>
                    <div class="w-full p-8" v-else>
                        <h3 class="block h3 mt-0">Logga in med lösenord (Företag)</h3>
                        <div v-if="loggedInError" class="p-4 bg-red-200 font-bold">
                            Felaktig kombination av personnummer och lösenord
                        </div>
                        <div>
                            <span>
                                <form class="mt-4" @submit.prevent="loginCompany">
                                    <div class="mb-2">
                                        <label for="Organisationsnummer" class="block uppercase text-sm font-bold mb-2">
                                            Organisationsnummer
                                        </label>
                                        <input
                                            name="Organisationsnummer"
                                            type="text"
                                            pattern="[0-9\-]+"
                                            placeholder="Organisationsnummer"
                                            autocomplete="username"
                                            class="bg-gray-100 focus:bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4 border-red-500 validated valid hf-in-range"
                                            aria-invalid="false"
                                            v-model="user.orgNumber" />
                                        <div v-if="v$.user.orgNumber.$error" class="text-red text-sm italic pb-2 h-6">
                                            <span v-if="v$.user.orgNumber.$errors[0].$validator === 'required'"
                                                >Fältet Organisationsnummer är obligatoriskt</span
                                            >
                                            <span
                                                v-if="
                                                    v$.user.orgNumber.$errors[0].$validator === 'validatePersonnummer'
                                                "
                                                >Ogiltigt organisationsnummer</span
                                            >
                                        </div>
                                    </div>
                                    <div>
                                        <span
                                            ><label for="Lösenord" class="block uppercase text-sm font-bold mb-2">
                                                Lösenord
                                            </label>
                                            <input
                                                name="Lösenord"
                                                type="password"
                                                placeholder="*********"
                                                autocomplete="off"
                                                class="bg-gray-100 focus:bg-white appearance-none block w-full bg-grey-lighter text-grey-darker border border-red rounded py-3 px-4"
                                                style="
                                                    background-repeat: no-repeat;
                                                    background-attachment: scroll;
                                                    background-size: 16px 18px;
                                                    background-position: 98% 50%;
                                                    cursor: auto;
                                                "
                                                v-model="user.password" />
                                            <div
                                                v-if="v$.user.password.$error"
                                                class="text-red text-sm italic pb-2 h-6">
                                                <span v-if="v$.user.password.$errors[0].$validator === 'required'"
                                                    >Fältet Lösenord är obligatoriskt</span
                                                >
                                            </div>
                                        </span>
                                    </div>
                                    <button
                                        role="button"
                                        type="submit"
                                        class="w-full p-2 px-4 text-white bg-mimer-purple mt-4 underline rounded-lg">
                                        Logga in
                                    </button>

                                    <div class="">
                                        <a
                                            role="button"
                                            class="inline-block text-sm mt-4 no-underline relative pl-6"
                                            @click.prevent="toggleCompanyLogin"
                                            ><span class="material-icons absolute left-0"> change_circle </span> Logga
                                            in som privatperson</a
                                        >
                                        <router-link
                                            role="link"
                                            class="inline-block text-sm mt-4 float-right no-underline"
                                            :to="'/glomt-losenord'"
                                            >Glömt lösenord</router-link
                                        >
                                    </div>
                                </form>
                            </span>
                        </div>

                        <a
                            href="/om-mimer/dataskydd-och-hantering-av-personuppgifter/generella-bestammelser-for-hantering-av-personuppgifter/"
                            class="text-sm block mt-6"
                            >Så hanterar vi dina personuppgifter och integritet.</a
                        >
                    </div>

                    <div class="w-full lg:hidden border-0 border-t-2 border-dashed border-gray-300"></div>
                    <div class="w-full p-8">
                        <h3 class="block h3 mt-0">Har du inget konto?</h3>
                        <p class="mb-4 pb-0">Förenkla ditt bostadssökande:</p>
                        <ul class="unstyled no-markers inline-block pl-0 mt-2 text-left">
                            <li><i class="material-icons text-green">done</i> Samla köpoäng i våra köer.</li>
                            <li><i class="material-icons text-green">done</i> Kom åt dina uppgifter överallt.</li>
                            <li>
                                <i class="material-icons text-green">done</i> Skapa ärenden och boka tid i tvättstugan.
                            </li>
                        </ul>
                        <div class="text-center mt-8">
                            <router-link
                                role="button"
                                class="inline-block p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline"
                                :to="'/registrera-dig'"
                                >Skapa ny användare</router-link
                            >
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div v-if="loggedInStatus">
            <div v-if="dashboard && userProfile">
                <h1 class="text-center font-normal text-black visually-hidden">Mina sidor</h1>

                <section class="entry-content bg-gray-100 py-8">
                    <NewsList />
                </section>

                <section v-if="userProfile.isResident && hasActiveContract" class="entry-content bg-white py-8">
                    <h2 class="h1 text-center font-normal text-black">Hyra och bo</h2>
                    <div class="flex flex-wrap" v-if="!!dashboard">
                        <div class="w-full md:w-1/2 md:pr-4 mx-auto relative">
                            <h3 class="box-title">Senaste ärenden</h3>
                            <div class="w-full">
                                <ul class="unstyled py-4">
                                    <li v-if="dashboard.workOrders.length == 0" class="w-full">
                                        <em class="block mx-auto text-center italic">Du har inga ärenden ännu</em>
                                    </li>
                                    <li v-for="workorder in dashboard.workOrders" :key="workorder.code" class="">
                                        <router-link
                                            :to="'/serviceanmalningar/?w=' + workorder.code"
                                            class="bg-white flex flex-wrap no-underline">
                                            <WorkOrderStatus :status="workorder.status" />
                                            <div class="p-2 flex flex-wrap flex-1 bg-gray-100">
                                                <div class="w-full">
                                                    {{
                                                        workorder.caption.includes('WEBB:')
                                                            ? workorder.caption.replace('WEBB:', '')
                                                            : workorder.caption
                                                    }}
                                                </div>
                                                <div class="w-1/2 text-sm">
                                                    Skapad {{ formatDate(workorder.registeredDate) }}
                                                </div>
                                                <div class="w-1/2 text-sm text-right">
                                                    {{ workorder.status }}
                                                </div>
                                            </div>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="w-full flex flex-wrap justify-around text-center">
                                <router-link
                                    role="button"
                                    class="inline-block w-full md:w-auto lg:w-auto p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline"
                                    :to="'/serviceanmalningar/skapa-serviceanmalan'"
                                    >Skapa serviceanmälan</router-link
                                >
                                <router-link
                                    role="button"
                                    class="inline-block w-full md:w-auto lg:w-auto p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline"
                                    :to="'/serviceanmalningar'"
                                    >Mina serviceanmälningar</router-link
                                >
                            </div>
                        </div>
                        <div
                            class="w-full md:w-1/2 md:pl-4 mx-auto relative"
                            v-if="dashboard.contracts.filter((contract) => contract.bookingSource !== 'none').length">
                            <h3 class="box-title">Mina bokningar</h3>
                            <div class="flex flex-wrap w-full mb-4 lg:mb-8 pb-8">
                                <div class="w-full">
                                    Här kan du göra bokningar till lägenheten. Det är olika för olika lägenheter, men
                                    kan till exempel vara:
                                </div>
                                <ul class="unstyled no-markers inline-block pl-0 my-2 text-left">
                                    <li><i class="material-icons text-mimer-purple">done</i> Tvättstuga</li>
                                    <li><i class="material-icons text-mimer-purple">done</i> Övernattningslägenhet</li>
                                    <li><i class="material-icons text-mimer-purple">done</i> Gemensamhetslokal</li>
                                    <li><i class="material-icons text-mimer-purple">done</i> Bastu</li>
                                </ul>
                                <div class="w-full">På bokningssidan kan du se vad du kan boka i ditt hus.</div>
                            </div>
                            <div class="w-full absolute bottom-0 text-center">
                                <router-link
                                    role="button"
                                    class="inline-block p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline"
                                    :to="'/bokningar'"
                                    >Bokningar</router-link
                                >
                            </div>
                        </div>
                    </div>
                </section>

                <section v-if="userProfile.isResident" class="entry-content bg-gray-100 py-8">
                    <h2 class="h1 text-center font-normal text-black">Min bostad</h2>
                    <div class="flex flex-wrap" v-if="!!dashboard">
                        <div class="w-full md:w-1/2 md:pr-4 mx-auto relative">
                            <h3 class="box-title">Mina senaste fakturor</h3>
                            <div class="w-full mb-4 lg:mb-8 pb-8">
                                <ul class="unstyled py-4">
                                    <li v-if="dashboard.invoices.length == 0" class="w-full">
                                        <em class="block mx-auto text-center italic">Du har inga fakturor ännu</em>
                                    </li>
                                    <li v-for="invoice in dashboard.invoices.slice(0, 3)" :key="invoice.id" class="">
                                        <router-link
                                            :to="'/fakturor/?f=' + invoice.invoiceNumber"
                                            class="bg-white flex flex-wrap no-underline">
                                            <figure
                                                class="relative xh-full w-10 text-center p-2 text-white"
                                                :class="{
                                                    'bg-mimer-purple': invoice.status === 'betald',
                                                    'bg-mimer-red':
                                                        invoice.status === 'obetald' ||
                                                        invoice.status == 'nytt inbetalningsdatum' ||
                                                        invoice.status === 'förfallen',
                                                }">
                                                <i
                                                    v-if="invoice.status === 'betald'"
                                                    class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
                                                    >check</i
                                                >
                                                <i
                                                    v-if="
                                                        invoice.status === 'obetald' ||
                                                        invoice.status == 'nytt inbetalningsdatum'
                                                    "
                                                    class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
                                                    >event</i
                                                >
                                                <i
                                                    v-if="invoice.status === 'förfallen'"
                                                    class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
                                                    >close</i
                                                >
                                            </figure>
                                            <div class="p-2 flex flex-wrap flex-1">
                                                <div class="w-1/3">{{ invoice.expireDate }}</div>
                                                <div class="w-2/3 text-right capitalize">
                                                    {{ invoice.status }}
                                                </div>
                                                <div class="w-1/2 text-sm">
                                                    {{ invoice.invoiceNumber }}
                                                </div>
                                                <div class="w-1/2 text-sm text-right">{{ invoice.amountToPay }} kr</div>
                                            </div>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="w-full absolute bottom-0 text-center">
                                <router-link
                                    role="button"
                                    class="inline-block p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline"
                                    :to="'/fakturor'"
                                    >Se alla fakturor</router-link
                                >
                            </div>
                        </div>
                        <div class="w-full md:w-1/2 md:pl-4 mx-auto relative">
                            <h3 class="box-title">Hyresavtal och hemförsäkring</h3>
                            <div class="w-full mb-4 lg:mb-8 pb-8">
                                <ul class="unstyled py-4">
                                    <li v-if="dashboard.contracts.length == 0" class="w-full">
                                        <em class="block mx-auto text-center italic">Du har inga kontrakt</em>
                                    </li>
                                    <li v-for="contract in dashboard.contracts" :key="contract.contractNumber" class="">
                                        <router-link
                                            :to="'/avtal/?c=' + contract.contractNumber"
                                            class="bg-white flex flex-wrap no-underline">
                                            <figure
                                                class="relative xh-full w-10 text-center p-2 bg-mimer-purple text-white">
                                                <i
                                                    v-if="contract.type === 'apartment'"
                                                    class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
                                                    >business</i
                                                >
                                                <i
                                                    v-if="contract.type === 'premises'"
                                                    class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
                                                    >view_day</i
                                                >
                                                <i
                                                    v-if="contract.type === 'parking'"
                                                    class="material-icons m-auto left-0 top-0 w-full mt-2 text-3xl"
                                                    >directions_car</i
                                                >
                                            </figure>
                                            <div class="p-2 flex flex-wrap flex-1">
                                                <div class="w-full">{{ contract.address }}</div>
                                                <div class="w-full text-sm">
                                                    <span v-if="contract.type === 'apartment'">Bostad</span>
                                                    <span v-if="contract.type === 'premises'">Förråd</span>
                                                    <span v-if="contract.type === 'parking'">Bilplats</span>
                                                </div>
                                            </div>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                            <div class="w-full absolute bottom-0 text-center">
                                <router-link
                                    role="button"
                                    class="inline-block p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline"
                                    :to="'/avtal'"
                                    >Se alla hyresavtal</router-link
                                >
                            </div>
                        </div>
                    </div>
                </section>

                <section v-if="userProfile.isApplicant" class="entry-content bg-white py-8">
                    <h2 class="h1 text-center font-normal text-black">Söka bostad</h2>
                    <div class="w-full flex flex-wrap">
                        <div v-if="userProfile.userType == 'person'" class="w-full md:w-1/2 md:p-4 md:mt-6 pr-4">
                            <div class="text-center mb-4" v-if="cleanedQueues.primaryQueue">
                                <span class="text-2xl">Du har just nu</span>
                                <b class="block h3 mt-0">{{ cleanedQueues.primaryQueue.points }} köpoäng</b>
                                <span class="text-2xl">i vår {{ cleanedQueues.primaryQueue.displayname }}</span>
                                <ul class="flex justify-center mt-4">
                                    <li
                                        v-for="queue in cleanedQueues.otherQueues"
                                        :key="queue.displayname"
                                        class="block mr-4">
                                        <strong>{{ queue.points }}</strong> köpoäng i
                                        {{ queue.displayname }}
                                    </li>
                                </ul>
                            </div>

                            <p class="text-sm md::px-12 mx-auto text-center">
                                För att stå kvar i kön och behålla dina köpoäng måste du logga in igen senast
                                {{ dashboard.vacancy.nextLoginDate.split('T')[0] }}.
                                <a href="https://www.mimer.nu/hyra-och-bo/om-var-uthyrning/om-kopoangen/"
                                    >Mer information om vårt kösystem</a
                                >
                            </p>
                        </div>
                        <div class="flex flex-col flex-1">
                            <a
                                role="button"
                                class="inline-block p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline text-center"
                                href="/sok-ledigt"
                                >Sök ledigt</a
                            >
                            <router-link
                                v-if="userProfile.userType == 'person'"
                                role="button"
                                class="inline-block p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline text-center"
                                :to="'/profil'"
                                >Mina köer</router-link
                            >
                            <router-link
                                role="button"
                                class="inline-block p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline text-center"
                                :to="'/prenumerationer'"
                                >Mina prenumerationer</router-link
                            >
                            <router-link
                                role="button"
                                class="inline-block p-2 px-4 text-white bg-mimer-purple mt-4 rounded-lg no-underline text-center"
                                :to="'/erbjudanden'"
                                >Intresseanmälningar och erbjudanden</router-link
                            >
                        </div>
                    </div>
                </section>

                <section v-if="userProfile.isResident" class="entry-content bg-gray-100 py-8">
                    <h2 class="h1 text-center font-normal text-black">Mimerkortet</h2>
                    <div class="flex flex-wrap">
                        <div class="w-full md:w-1/3">
                            <img src="/app/uploads/2024/12/mimerkortet2025.png" alt="Mimerkortet" class="" />
                        </div>
                        <div class="w-full md:w-2/3 mt-0 md:mt-6 pl-0 md:px-6">
                            <p>
                                Här är ditt digitala Mimerkort. Visa upp det för att få rabatter och förmåner hos flera
                                olika företag och idrottsföreningar i Västerås. Alla erbjudanden hittar du på sidan
                                <a
                                    href="https://mimer.nu/hyra-och-bo/for-dig-som-bor-hos-mimer/mimerkortet/"
                                    class="_underline"
                                    >Mimerkortet.
                                </a>
                            </p>
                            <p class="pt-4">Mimerkortet är personligt och får ej överlåtas.</p>
                        </div>
                    </div>
                </section>

                <section v-if="activeCityPartActivities" class="entry-content bg-white py-8">
                    <h2 class="h1 text-center font-normal text-black">Stadsdelsaktiviteter</h2>
                    <div class="flex flex-wrap">
                        <div class="w-full md:w-2/3">
                            <p>{{ cityPartActivity_preamble }}</p>
                        </div>
                        <div class="w-full md:w-1/3"></div>
                    </div>
                    <div class="flex flex-wrap">
                        <div class="w-full md:w-1/2 md:pr-4">
                            <div v-html="cityPartActivity_one"></div>
                            <div v-html="cityPartActivity_three"></div>
                        </div>
                        <div class="w-full md:w-1/2">
                            <div v-html="cityPartActivity_two"></div>
                            <div v-html="cityPartActivity_four"></div>
                        </div>
                    </div>
                </section>

                <section
                    class="entry-content bg-white py-8"
                    v-if="userProfile.userType == 'person' && !userProfile.isApplicant">
                    <h2 class="h1 text-center font-normal text-black">Köplats</h2>
                    <div class="flex flex-wrap">
                        <p class="w-full md:w-2/3 mx-auto">
                            För att söka lägenhet, bilplats eller förråd behöver du ställa dig i kö. Det gör du genom
                            att gå till Valda köer när uppdaterar dina uppgifter under Min profil.
                        </p>
                        <div class="w-full text-center">
                            <router-link
                                role="button"
                                class="w-full md:w-auto mx-auto p-2 px-8 text-white bg-mimer-purple mt-4 rounded-lg no-underline text-center"
                                :to="'/profil/redigera'"
                                >Uppdatera uppgifter</router-link
                            >
                        </div>
                    </div>
                </section>
                <div></div>
            </div>

            <div
                v-else
                class="full-width-bar preload-screen"
                style="
                    height: 100vh;
                    background-color: #fff;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    position: relative;
                ">
                <div style="margin: -30vh auto 0">
                    <img src="/app/uploads/2018/09/mimerlogo_blk-turquoise.svg" alt="Logotyp" />
                    <p id="preload-screen-info-text">Laddar innehåll...</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useValidate from '@vuelidate/core';
import { authStore } from '../stores/auth';
import { userStore } from '../stores/user';
import { dashboardStore } from '../stores/dashboard';
import WorkOrderStatus from '@/components/WorkOrder/WorkOrderStatus.vue';
import { required } from '@vuelidate/validators';
import { validatePersonnummer, validateOrganisationNumber } from '../utils/helpers';
import { mapState, mapActions } from 'pinia';
import NewsList from '../components/Common/NewsList.vue';

export default {
    name: 'StartPage',
    components: {
        NewsList,
        WorkOrderStatus,
    },
    data() {
        return {
            v$: useValidate(),
            companyLogin: false,
            redirection: null,
            user: {
                userName: '',
                orgNumber: '',
                password: '',
                timeToLive: 0,
            },
            testUserProfile: null,

            activeMessageLogin: window.webappSettings ? window.webappSettings.activeMessageLogin : null,
            messageOnLoginPage: window.webappSettings ? window.webappSettings.messageOnLoginPage : null,
            intervalId: null,
        };
    },

    validations() {
        return {
            user: {
                userName: { required, validatePersonnummer },
                orgNumber: { required, validateOrganisationNumber },
                password: { required },
            },
        };
    },

    computed: {
        ...mapState(authStore, {
            loggedInStatus: 'loggedInStatus',
            loggedInError: 'loggedInError',
            bankIdUrl: 'bankIdUrl',
            scriveBankIdUrl: 'scriveBankIdUrl',
            hasSessionEnded: 'hasSessionEnded',
            loggedOut: 'loggedOut',
            isLogingIn: 'isLogingIn',
            details: 'details',
        }),
        ...mapState(dashboardStore, {
            dashboard: 'dashboard',
            cleanedQueues: 'cleanedQueues',
        }),
        ...mapState(userStore, {
            userProfile: 'userProfile',
        }),

        hasActiveContract() {
            return !!this.dashboard.contracts.filter((o) => o.contractNumber !== this.dashboard.commingContract).length;
        },
        activeCityPartActivities() {
            return window.webappSettings ? window.webappSettings.activeCityPartActivities : null;
        },
        cityPartActivity_preamble() {
            return window.webappSettings ? window.webappSettings.CityPartActivity_preamble : null;
        },
        cityPartActivity_one() {
            return window.webappSettings ? window.webappSettings.CityPartActivity_one : null;
        },
        cityPartActivity_two() {
            return window.webappSettings ? window.webappSettings.CityPartActivity_two : null;
        },
        cityPartActivity_three() {
            return window.webappSettings ? window.webappSettings.CityPartActivity_three : null;
        },
        cityPartActivity_four() {
            return window.webappSettings ? window.webappSettings.CityPartActivity_four : null;
        },
    },

    methods: {
        ...mapActions(authStore, ['fetchBankIDUrl', 'scriveFetchBankIDUrl', 'signInUser', 'invalidateUser']),
        ...mapActions(dashboardStore, ['fetchDashboardData']),
        ...mapActions(userStore, ['fetchUserData']),

        saveRedirections() {
            //If the user should be redirected store that redirection for later
            if (this.redirection) {
                sessionStorage.setItem('redirection', this.redirection);
            }
        },

        loginUser() {
            // checks all inputs
            this.v$.$validate();
            // if password and username is valid
            if (!this.v$.user.password.$invalid && !this.v$.user.userName.$invalid) {
                //If the user should be redirected store that redirection for later
                this.saveRedirections();
                //Sign in the user
                this.signInUser(this.user);
            } else {
                //
            }
        },

        loginCompany() {
            // checks all inputs
            this.v$.$validate();
            // if password and orgnumber is valid
            if (!this.v$.user.password.$invalid && !this.v$.user.orgNumber.$invalid) {
                //set the orgNumber as the userName
                this.user.userName = this.user.orgNumber;
                //If the user should be redirected store that redirection for later
                this.saveRedirections();
                //Sign in the user
                this.signInUser(this.user);
            } else {
                //
            }
        },

        toggleCompanyLogin() {
            this.companyLogin = !this.companyLogin;
        },

        signinBankID() {
            //If the user should be redirected store that redirection for later
            this.saveRedirections();
            //Sign in the user
            location.href = this.bankIdUrl;
        },
        scriveSignInBankId() {
            //If the user should be redirected store that redirection for later
            this.saveRedirections();
            //Sign in the user
            location.href = this.scriveBankIdUrl;
        },
        formatDate(date) {
            let dateArray = date.split(' ')[0].split('-');
            return parseInt(dateArray[2]) + '/' + parseInt(dateArray[1]);
        },
    },

    watch: {
        async loggedInStatus() {
            //If the user has a redirect this takes priority
            if (this.redirection) {
                if (this.redirection.includes('sok-ledigt')) {
                    location.href = location.origin + '/' + this.redirection;
                } else {
                    this.$router.replace({ path: this.redirection });
                }
            }
            //Else send the user to the dashboard
            else {
                if (this.loggedInStatus) {
                    this.fetchDashboardData();
                    await this.fetchUserData();

                    //          const store = userStore();
                    //          let tempUserProfile = store.userProfile;
                    //          if (!tempUserProfile.isApplicant && !tempUserProfile.isResident) {
                    //            this.invalidateUser('applicant');
                    //          }
                }
            }
        },
    },

    async created() {
        //Check for a redirection url as a query param or from session storage
        this.redirection = this.$route.query.redirection;

        // If the user is not loged in get a BankID redirect url
        if (!this.loggedInStatus) {
            this.fetchBankIDUrl();
            // this.scriveFetchBankIDUrl();
        } else {
            this.fetchDashboardData();
            await this.fetchUserData();

            //      const store = userStore();
            //      let tempUserProfile = store.userProfile;
            //      if (!tempUserProfile.isApplicant && !tempUserProfile.isResident) {
            //          this.invalidateUser('applicant');
            //      }
        }
    },

    async mounted() {
        this.intervalId = setInterval(() => {
            this.fetchBankIDUrl();
        }, 30000);
    },

    beforeUnmount() {
        clearInterval(this.intervalId);
    },
};
</script>
